import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonRow,
  IonCol,
  IonIcon,
  IonPopover,
  IonItemDivider,
  IonItem,
  IonInput,
  IonLabel,
  IonModal,
  IonList,
} from '@ionic/react';
import ExploreContainer from '../components/ExploreContainer';
import './Ordini.css';
import IOrdini from '../interfaces/IOrdini';
import IMenu from '../interfaces/IMenu';
import IComanda from '../interfaces/IComanda';

/*ICONS */
import { addCircle } from 'ionicons/icons';
import { chevronBackCircle } from 'ionicons/icons';
import { save } from 'ionicons/icons';
import { close } from 'ionicons/icons';
import { ADDRCONFIG } from 'dns';
import { checkmark } from 'ionicons/icons';
import { closeCircle } from 'ionicons/icons';

const Ordini: React.FC = () => {
  var history = useHistory();

  const [AddRowOrdini, setAddRowOrdini] = useState<boolean>(false);


  const [elencoOrdini, setElencoOrdini] = useState<Array<IOrdini>>([]);
  const [inserimentoComanda, setComande] = useState<Array<IMenu>>([]);
  const [AddRowMenu, setAddRowMenu] = useState<boolean>(false);


  const [btnApertiClass, setBtnApertiClass] = useState(false);
  const [btnApertiColor, setBtnApertiColor] = useState("#a2282a");

  useEffect(() => {

    var dati: Array<IOrdini> = [
      {
        nome: 'roberto',
        qtInizio: 8,
        qtFine: 8,
        ora: '20:30'
      },
      {
        nome: 'roberto',
        qtInizio: 0,
        qtFine: 5,
        ora: '21:30'
      },
      {
        nome: 'roberto',
        qtInizio: 0,
        qtFine: 6,
        ora: '19:30'
      }

    ]

    setElencoOrdini(dati);

  }, []);


  useEffect(() => {

    var dati: Array<IMenu> = [
      {
        nome: 'margherita',
        tempo: 70,
        impostazioni: 'pizza al mattone'
      },
      {
        nome: 'bufala',
        tempo: 40,
        impostazioni: 'pinsa'
      },
      {
        nome: 'napoli',
        tempo: 80,
        impostazioni: 'teglia'
      }

    ]

    setComande(dati);

  }, []);








  return (
    <>
      <IonPage >
        <ExploreContainer name="Home page" />

        <IonHeader style={{ height: "6%" }}>

          <IonToolbar style={{ height: "100%" }} class={'host'}>
            <IonRow style={{ height: "100%" }}>
              <IonCol size="10" >
                <IonTitle class={'background-content'} style={{ fontSize: "30px", textAlign: "center" }}>Ordini</IonTitle>
              </IonCol>
              <IonCol size="2" >
                <IonButton onClick={() => { setAddRowOrdini(true) }} fill="clear" style={{ height: "auto" }}>
                  <IonIcon icon={addCircle} style={{ color: "white", fontSize: "50px" }}></IonIcon>
                </IonButton>
              </IonCol>
            </IonRow>
          </IonToolbar>

        </IonHeader>




        <IonContent class={'background-content'} fullscreen >

          <IonRow style={{ height: "15%", justifyContent: "center" }}>

            <IonCol style={{ height: "70%", marginTop: "3%"}} size="4">
              <IonButton class={'btnApertiClass'} onClick={() => {
                btnApertiClass ? setBtnApertiClass(false) : setBtnApertiClass(true);
                btnApertiColor === "#a2282a" ? setBtnApertiColor("#B9B9B9") : setBtnApertiColor("#a2282a");
                
              }}
                className={btnApertiClass ? "btnClass clicked" : "btnClass"}
                style={{ backgroundColor: btnApertiColor, marginLeft: "25px", color: "white", height: "70%", width: "80%", borderRadius: "10px", fontSize: "25px", fontFamily: 'bahnschrift'}}>Aperti
              </IonButton>
              
            </IonCol>
            <IonCol style={{ height: "70%", marginTop: "3%" }} size="4">
              <IonButton class={'btnBorder'} style={{ backgroundColor: "#a2282a", marginLeft: "25px", color: "white", height: "70%", width: "80%", borderRadius: "10px", fontSize: "25px",fontFamily: 'bahnschrift' }} fill="clear" >Chiusi </IonButton>
            </IonCol>
            <IonCol style={{ height: "70%", marginTop: "3%" }} size="4">
              <IonButton class={'btnBorder'} style={{ backgroundColor: "#a2282a", marginLeft: "25px", color: "white", height: "70%", width: "80%", borderRadius: "10px", fontSize: "25px", alignItems: "center",fontFamily: 'bahnschrift' }} fill="clear" >Tutti </IonButton>
            </IonCol>
          </IonRow>


          <IonRow class={'righePreset'} style={{ marginTop: "40px" }}>

            <IonCol size="4" style={{ paddingLeft: "10px", height: "15%", fontSize: "27px", backgroundColor: "#a2282a", color: "white" }}> <div style={{ textAlign: "center",fontFamily: 'bahnschrift' }}>Nome</div></IonCol>

            <IonCol size="2" style={{ paddingLeft: "10px", height: "15%", fontSize: "27px", backgroundColor: "#a2282a", color: "white" }}> <div style={{ textAlign: "center",fontFamily: 'bahnschrift' }}>Quantità</div></IonCol>

            <IonCol size="2" style={{ paddingLeft: "10px", height: "15%", fontSize: "27px", backgroundColor: "#a2282a", color: "white" }}><div style={{ textAlign: "center",fontFamily: 'bahnschrift' }} >Ora</div> </IonCol>

            <IonCol size="3" style={{ paddingLeft: "10px", height: "15%", fontSize: "27px", backgroundColor: "#a2282a", color: "white" }}><div style={{ textAlign: "center",fontFamily: 'bahnschrift' }} >Chiusura</div> </IonCol>

          </IonRow>


          {elencoOrdini.map(ordine =>
            <IonRow class={'righePreset'}>

              <IonCol size="4" class={'borderTab'} style={{ borderLeft: "2px solid gray", paddingTop: "15px", paddingLeft: "10px", fontSize: "28px", backgroundColor: "white" }}> <div style={{ textAlign: "left",fontFamily: 'bahnschrift' }}>{ordine.nome}</div></IonCol>

              <IonCol size="2" class={'borderTab'} style={{ paddingTop: "15px", paddingLeft: "10px", fontSize: "28px", backgroundColor: "white" }}> <div style={{ textAlign: "left",fontFamily: 'bahnschrift' }}>{ordine.qtInizio} / {ordine.qtFine}</div></IonCol>

              <IonCol size="2" class={'borderTab'} style={{ paddingTop: "15px", paddingLeft: "10px", fontSize: "28px", backgroundColor: "white" }}><div style={{ textAlign: "left",fontFamily: 'bahnschrift' }} >{ordine.ora}</div> </IonCol>

              <IonCol size="3" class={'borderTab'} style={{ backgroundColor: "white", textAlign: "center" }} >
                <IonButton class={'buttonCheckOrdine'} style={{ borderRadius: "0px", width: "80px", height: "50px" }} >
                  <IonIcon class={'iconaChiusura'}icon={closeCircle} style={{ background: "transparent", color: "#a2282a", fontSize: "70px", borderRadius: "30px", alignItems: "center" }}></IonIcon>
                </IonButton>
              </IonCol>

            </IonRow>
          )}

        </IonContent>

      </IonPage>

      <IonModal class={'fullscreen'} isOpen={AddRowOrdini} onDidDismiss={() => { setAddRowOrdini(false) }}>

        <IonLabel style={{ backgroundColor: "#a2282a", color: "white",fontFamily:"Bahnschrift", height: "50px", fontSize: "25px", paddingleft: "7%", paddingTop: "5px", paddingBottom: "10px", textAlign: "center" }}>Comanda Nr #</IonLabel>

        <IonRow style={{ paddingTop: "2px", paddingLeft: "3%" }}>
          <IonCol size="2" style={{ paddingLeft: "4%", marginTop: "12px" }}>
            <IonLabel style={{ color: "#a2282a", fontSize: "25px", paddingleft: "3%",fontFamily:"Bahnschrift", paddingTop: "5px", paddingBottom: "10px", textAlign: "center" }}>Data</IonLabel>
          </IonCol>
          <IonCol size="3" style={{ marginTop: "2px" }}>
            <IonInput style={{ fontSize: "25px", textAlign: "left", height: "50px", width: "100%",fontFamily:"Bahnschrift" }} type="text">11/02/2022</IonInput>
          </IonCol>
          <IonCol size="2" style={{ marginTop: "12px" }}>
            <IonLabel style={{ color: "#a2282a", fontSize: "25px", paddingleft: "9%",fontFamily:"Bahnschrift", paddingTop: "5px", paddingBottom: "10px", textAlign: "right" }}>Ora</IonLabel>
          </IonCol>
          <IonCol size="3" style={{ marginTop: "2px" }}>
            <IonInput style={{ fontSize: "25px", textAlign: "left", height: "50px", width: "100%", fontFamily:"Bahnschrift"}} type="text">12:30</IonInput>
          </IonCol>
        </IonRow>

        <IonRow style={{ paddingTop: "20px", paddingLeft: "3%" }} >
          <IonCol size="4" style={{ paddingTop: "14px", paddingLeft: "4%" }}>
            <IonLabel style={{ color: "#a2282a", fontSize: "25px", paddingleft: "3%", paddingBottom: "10px", textAlign: "center",fontFamily:"Bahnschrift" }}>Cliente / Tavolo:</IonLabel>
          </IonCol>
          <IonCol size="4" style={{}}>
            <IonInput style={{ fontSize: "25px", textAlign: "left", height: "50px", width: "152%",fontFamily:"Bahnschrift" }} type="text">Mario Rossi</IonInput>
          </IonCol>
        </IonRow>



        <IonRow class={'righePreset'} style={{ marginTop: "40px" }}>

          <IonCol size="3" style={{ paddingLeft: "5px", height: "90%", fontSize: "27px", backgroundColor: "#a2282a", color: "white" }}> <div style={{ textAlign: "center", paddingTop: "10px",fontFamily:"Bahnschrift" }}>Prodotto</div></IonCol>

          <IonCol size="2" style={{ paddingLeft: "5px", height: "90%", fontSize: "27px", backgroundColor: "#a2282a", color: "white" }}> <div style={{ textAlign: "center", paddingTop: "10px",fontFamily:"Bahnschrift" }}>Quantità</div></IonCol>

          <IonCol size="4" style={{ paddingLeft: "10px", height: "90%", fontSize: "27px", backgroundColor: "#a2282a", color: "white" }}><div style={{ textAlign: "center", paddingTop: "10px",fontFamily:"Bahnschrift" }} >Note</div>
          </IonCol>
          <IonCol size="2" style={{ height: "90%", backgroundColor: "#a2282a" }}>
            <IonButton onClick={() => { setAddRowMenu(true) }} class={'buttonAddOrdine'} style={{ height: "50px", paddingLeft: "10%" }} >
              <IonIcon icon={addCircle} style={{ fontSize: "45px", height: "90%", alignItems: "center" }}></IonIcon>
            </IonButton>
          </IonCol>







        </IonRow>







        <IonRow style={{ paddingTop: "70%", paddingLeft: "10%" }}>
          <IonCol size="3" style={{ alignItems: "left" }} >
            <IonButton onClick={() => { setAddRowOrdini(false) }} fill="clear" style={{ height: "60px", color: "white", background: "red", width: "80%" }}>
              <IonIcon icon={close} style={{ color: "white", fontSize: "50px" }}></IonIcon>
              ANNULLA</IonButton>
          </IonCol>

          <IonCol size="3" style={{ alignItems: "right" }}>
            <IonButton onClick={() => { }} fill="clear" style={{ height: "60px", color: "white", background: "green", width: "80%" }}>
              <IonIcon icon={save} style={{ color: "white", fontSize: "50px" }}></IonIcon>

              SALVA</IonButton>
          </IonCol>
        </IonRow>
      </IonModal>








      <IonPopover class={'popMenu'} style={{}} isOpen={AddRowMenu} onDidDismiss={() => { setAddRowMenu(false) }}>

        <IonLabel style={{ backgroundColor: "#a2282a", color: "white", fontSize: "25px", paddingleft: "7%", paddingTop: "5px", paddingBottom: "10px", textAlign: "center" }}>Elenco Pizze</IonLabel>
        <IonList style={{ borderRight: "1px solid grey", borderLeft: "1px solid grey", borderBottom: "1px solid grey" ,fontFamily:"Bahnschrift"}}>
          <IonItem>
            <IonLabel style={{ fontSize: "25px", color: "#a2282a",fontFamily:"Bahnschrift" }}>Margherita</IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel style={{ fontSize: "25px", color: "#a2282a",fontFamily:"Bahnschrift" }}>Bufala</IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel style={{ fontSize: "25px", color: "#a2282a",fontFamily:"Bahnschrift" }}>Napoli</IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel style={{ fontSize: "25px", color: "#a2282a" ,fontFamily:"Bahnschrift"}}>Capricciosa</IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel style={{ fontSize: "25px", color: "#a2282a",fontFamily:"Bahnschrift" }}>4 Stagioni</IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel style={{ fontSize: "25px", color: "#a2282a",fontFamily:"Bahnschrift" }}>Cotto e Funghi</IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel style={{ fontSize: "25px", color: "#a2282a",fontFamily:"Bahnschrift" }}>Diavola</IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel style={{ fontSize: "25px", color: "#a2282a" ,fontFamily:"Bahnschrift"}}>Speck e Mascarpone</IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel style={{ fontSize: "25px", color: "#a2282a",fontFamily:"Bahnschrift" }}>4 Formaggi</IonLabel>
          </IonItem>
        </IonList>

      </IonPopover>


    </>
  );
};

export default Ordini;
